import { useQuery } from '@tanstack/react-query';
import {
  fetchActiveSessionSummary,
  fetchDashboardStats,
} from '../api/dashboardApi';

/** Ключи разделены, чтобы инвалидация после сессии могла дёрнуть только
 *  то, что меняется (due-count, stats, active), не трогая остального кеша. */
export const dashboardKeys = {
  stats: ['dashboard', 'stats'] as const,
  dueCount: ['dashboard', 'due-count'] as const,
  active: ['dashboard', 'active-session'] as const,
};

export function useDashboardStatsQuery() {
  return useQuery({
    queryKey: dashboardKeys.stats,
    queryFn: fetchDashboardStats,
    // Stats всегда хочется свежие — слегка устаревшие числа в KPI бесят
    // больше, чем лишний роундтрип. На горячей навигации react-query
    // вернёт кеш и параллельно сделает revalidate.
    staleTime: 0,
  });
}

/** Активная сессия (если есть) — для плашки «Продолжить». staleTime: 0, чтобы
 *  после выхода из сессии дашборд сразу показал актуальный прогресс. */
export function useActiveSessionQuery() {
  return useQuery({
    queryKey: dashboardKeys.active,
    queryFn: fetchActiveSessionSummary,
    staleTime: 0,
  });
}
